module.exports = __webpack_public_path__ + "img/A2.f3d53d1a.svg";